import script from "./ShareholderCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareholderCard.vue?vue&type=script&setup=true&lang=ts"

import "./ShareholderCard.vue?vue&type=style&index=0&id=1c329cbe&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c329cbe"]])

export default __exports__